import useSite from "./useSite";

// I know, a silly hook, leave me alone
export default function useInspectionsListUrl() {
  const site = useSite();
  return `/${site}/permits/inspections`;
}
